import { render, staticRenderFns } from "./UsageSMSTopTenPieChart.vue?vue&type=template&id=4f8cb3b2&scoped=true&"
import script from "./UsageSMSTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./UsageSMSTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cb3b2",
  null
  
)

export default component.exports